/** Entrada. Sem cadastro aberto: as contas são criadas pela linha de comando. */

import { useState } from "react";
import { Field, Key } from "../components/ui";
import { useSession } from "../lib/session";

export function Login() {
  const { entrar } = useSession();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (err) {
      setErro((err as Error).message);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login">
      <form onSubmit={submit}>
        <div className="brand">
          <i />
          Fluxo
        </div>
        <Field label="E-mail">
          <input
            type="email"
            autoComplete="username"
            value={email}
            autoFocus
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>
        <Field label="Senha">
          <input
            type="password"
            autoComplete="current-password"
            value={senha}
            required
            onChange={(e) => setSenha(e.target.value)}
          />
        </Field>
        {erro && (
          <div className="banner" role="alert">
            {erro}
          </div>
        )}
        <Key type="submit" primary wide disabled={enviando}>
          {enviando ? "Entrando…" : "Entrar"}
        </Key>
      </form>
    </div>
  );
}
